/**
 * <jv-ship-countdown> — counts down to the next midnight in the visitor's own
 * device timezone and writes the remaining time into [data-jv-shipcd-time].
 *
 * Registered defensively: the snippet emits one script tag per block, and the
 * theme editor re-renders blocks, so the definition may be requested twice.
 */
(function () {
  if (customElements.get('jv-ship-countdown')) return;

  function msUntilLocalMidnight() {
    var now = new Date();
    var midnight = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() + 1,
      0,
      0,
      0,
      0
    );
    return midnight.getTime() - now.getTime();
  }

  function format(ms, showSeconds) {
    var total = Math.max(0, Math.floor(ms / 1000));
    var hours = Math.floor(total / 3600);
    var minutes = Math.floor((total % 3600) / 60);
    var seconds = total % 60;

    var parts = [];
    if (hours > 0) parts.push(hours + 'h');
    if (hours > 0 || minutes > 0) parts.push(minutes + 'm');
    if (showSeconds || parts.length === 0) parts.push(seconds + 's');
    return parts.join(' ');
  }

  class ShipCountdown extends HTMLElement {
    connectedCallback() {
      this.output = this.querySelector('[data-jv-shipcd-time]');
      if (!this.output) return;

      this.showSeconds = this.dataset.showSeconds === 'true';
      this.tick();
      this.timer = setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      this.output.textContent = format(msUntilLocalMidnight(), this.showSeconds);
      this.classList.remove('jv-shipcd--pending');
    }
  }

  customElements.define('jv-ship-countdown', ShipCountdown);
})();
